// | ------------------------------------------------------------------------
// | Template Components
// | ------------------------------------------------------------------------ 

import '@popperjs/core' // Popper is required for dropdowns, popovers and tooltips.
//import { Dropdown } from 'bootstrap';   

import Dropdown from 'bootstrap/js/dist/dropdown';

import Splide from '@splidejs/splide'; //? https://splidejs.com/
import LazyLoad from "vanilla-lazyload"


// Header
import './components/fixedHeader';

// Navigation
import './components/menuDropdownHover';
//import './components/mobileSelectNav';
import './components/mobileMenu';

// Content
import './components/imageLazyLoad';
import './components/webp';
//import './components/quantityInput';
//import './components/productGallery';

import './components/cookieConsent/cookieOptions';



document.addEventListener( 'DOMContentLoaded', function () {

    var heroCarousel = document.querySelector(".hero-carousel");

    if(heroCarousel){
	
        var homeCarousel = new Splide( '.hero-carousel', {
            arrows     : false,
            type       : 'loop',            
            perPage    : 1,
			perMove    : 1,            
            autoplay   : true,            
            //rewind     : true,
            pagination : false,
            //pauseOnHover: false	,

        });
        
        homeCarousel.mount();

        homeCarousel.on( 'move', function() {  

            const elements = document.querySelectorAll('.text-fade');

            for(var i=0; i< elements.length; i++){
                elements[i].classList.remove('fadeInLeft');
            }
            
        });   
        
        homeCarousel.on( 'moved', function() {  

            const elements = document.querySelectorAll('.text-fade');

            for(var i=0; i< elements.length; i++){
                elements[i].classList.add('fadeInLeft');
            } 
            
        }); 
    
    }

    var accreditationCarousel = document.querySelector(".accreditations");

    if(typeof(accreditationCarousel) != 'undefined' && accreditationCarousel != null){    

        var accreditations = new Splide( '.accreditations', {
            type       : 'loop',
            perPage    : 5,
            pagination : false,
            arrows     : false,
            lazyLoad   : 'nearby',
            breakpoints: {
                992: {
                    perPage: 5,                
                },
                768: {
                    perPage: 3,
                    arrows: true
                },
                540: {
                    perPage: 2,
                    arrows: true
                },                        
            }        
        });
        
        accreditations.mount();   
    
    }

});




// | ------------------------------------------------------------------------